import {
  collection,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";
import { db } from "../config/firebase";
import { NewsModel } from "../../types/news";

class NewsService {
  constructor() {
    this.newsCollection = collection(db, "news");
  }

  /**
   * ✅ Create or Update a News Item
   * @param {Object} news - NewsModel object
   */
  async addOrUpdateNews(news) {
    try {
      const newsRef = doc(this.newsCollection, news.id);
      await setDoc(newsRef, news.toMap());
      console.log("News item added/updated successfully");
    } catch (error) {
      console.error("Error adding/updating news:", error);
      throw error;
    }
  }

  /**
   * 📖 Get All News
   * @returns {Promise<Array>} Array of NewsModel objects
   */
  async getAllNews() {
    try {
      const querySnapshot = await getDocs(this.newsCollection);
      return querySnapshot.docs.map((doc) => NewsModel.fromDoc(doc));
    } catch (error) {
      console.error("Error getting all news:", error);
      throw error;
    }
  }

  /**
   * 🔍 Get News by Type
   * @param {string} type - News type to filter by
   * @returns {Promise<Array>} Array of filtered NewsModel objects
   */
  async getNewsByType(type) {
    try {
      const q = query(this.newsCollection, where("type", "==", type));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => NewsModel.fromDoc(doc));
    } catch (error) {
      console.error("Error getting news by type:", error);
      throw error;
    }
  }

  /**
   * 🗑️ Delete a Specific News Item
   * @param {string} id - ID of the news item to delete
   */
  async deleteNews(id) {
    try {
      const newsRef = doc(this.newsCollection, id);
      await deleteDoc(newsRef);
      console.log("News item deleted successfully");
    } catch (error) {
      console.error("Error deleting news:", error);
      throw error;
    }
  }

  /**
   * 🧹 Delete All News
   */
  async deleteAllNews() {
    try {
      const batch = writeBatch(db);
      const querySnapshot = await getDocs(this.newsCollection);

      querySnapshot.docs.forEach((document) => {
        batch.delete(document.ref);
      });

      await batch.commit();
      console.log("All news items deleted successfully");
    } catch (error) {
      console.error("Error deleting all news:", error);
      throw error;
    }
  }
}

// Export as singleton instance
export const newsService = new NewsService();
export default NewsService;
